import { pickBy } from 'lodash';
import { deleteBlockText, createBlock, getBlockAtStartOfSelection, replaceWithEmptyBlock, Modifier, EditorState, SelectionState, insertLinkInPosition } from 'wix-rich-content-editor-common';

const DEFAULTS = {
  config: {
    alignment: "center",
    size: "content",
    link: {
      target: "_blank",
      rel: ""
    }
  }
};

const LINK_PREVIEW_TYPE = "wix-draft-plugin-link-preview";

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const addLinkPreview = async (editorState, config, blockKey, linkData) => {
  const {
    enableEmbed = true,
    enableLinkPreview = true,
    fetchData
  } = config[LINK_PREVIEW_TYPE] || {};
  const linkPreview = await fetchLinkPreview(fetchData, linkData.url) || {};
  const { title, html, fixedUrl } = linkPreview;
  if (shouldAddEmbed(html, enableEmbed, fixedUrl) || shouldAddLinkPreview(title, enableLinkPreview)) {
    const linkPreviewData = await createLinkPreviewData(
      linkData,
      linkPreview,
      config[LINK_PREVIEW_TYPE]
    );
    addLinkPreviewBlock(editorState, config, blockKey, linkPreviewData);
  }
};
const fetchLinkPreview = async (fetchData, url) => {
  const fixedUrl = url.split("\u21B5").join("");
  const { thumbnail_url, title, description, html } = await (fetchData == null ? void 0 : fetchData(fixedUrl)) || {};
  return { thumbnailUrl: thumbnail_url, title, description, html, fixedUrl };
};
const createLinkPreviewData = async (linkData, { thumbnailUrl, title, description, html, fixedUrl }, linkPreviewConfig) => {
  const currentConfig = __spreadValues(__spreadValues({}, DEFAULTS), linkPreviewConfig).config;
  const data = {
    config: __spreadProps(__spreadValues({}, currentConfig), {
      link: __spreadProps(__spreadValues(__spreadValues({}, currentConfig.link), pickBy(linkData)), { url: fixedUrl }),
      width: html && 350
    }),
    thumbnail_url: thumbnailUrl,
    title,
    description,
    html
  };
  if (thumbnailUrl && await isValidImgSrc(thumbnailUrl)) {
    data.thumbnail_url = thumbnailUrl;
  }
  return data;
};
const addLinkPreviewBlock = async (editorState, config, blockKey, linkPreviewData) => {
  const { setEditorState } = config;
  const withoutLinkBlock = deleteBlockText(editorState, blockKey);
  const { newEditorState } = createBlock(withoutLinkBlock, linkPreviewData, LINK_PREVIEW_TYPE);
  setEditorState(newEditorState);
};
const isValidImgSrc = (url) => {
  return new Promise((resolve) => {
    const image = document.createElement("img");
    image.src = url;
    image.onload = () => {
      resolve(true);
    };
    image.onerror = () => {
      resolve(false);
    };
  });
};
const shouldAddLinkPreview = (title, enableLinkPreview) => enableLinkPreview && title;
const shouldAddEmbed = (html, enableEmbed, url) => {
  if (Array.isArray(enableEmbed)) {
    return enableEmbed.filter((whiteListType) => url.toLowerCase().includes(whiteListType.toLowerCase())).length > 0;
  }
  return html && enableEmbed;
};
const convertLinkPreviewToLink = (editorState) => {
  let currentBlock = getBlockAtStartOfSelection(editorState);
  const blockKey = currentBlock.getKey();
  const url = getLinkPreviewUrl(editorState, currentBlock);
  let newState = replaceWithEmptyBlock(editorState, currentBlock.getKey());
  const contentState = Modifier.insertText(
    newState.getCurrentContent(),
    newState.getSelection(),
    url
  );
  currentBlock = contentState.getBlockForKey(currentBlock.getKey());
  const nextBlock = contentState.getBlockAfter(currentBlock.getKey());
  newState = EditorState.push(newState, contentState, "change-block-type");
  const editorStateWithLink = changePlainTextUrlToLinkUrl(newState, blockKey, url);
  const newLineSelection = new SelectionState({
    anchorKey: nextBlock.getKey(),
    anchorOffset: 0,
    focusKey: nextBlock.getKey(),
    focusOffset: 0
  });
  return EditorState.forceSelection(editorStateWithLink, newLineSelection);
};
const getLinkPreviewUrl = (editorState, block) => {
  var _a, _b, _c;
  const entityKey = block.getEntityAt(0);
  const entityData = (_a = editorState.getCurrentContent().getEntity(entityKey)) == null ? void 0 : _a.getData();
  return (_c = (_b = entityData == null ? void 0 : entityData.config) == null ? void 0 : _b.link) == null ? void 0 : _c.url;
};
const changePlainTextUrlToLinkUrl = (editorState, blockKey, url) => {
  return insertLinkInPosition(
    EditorState.push(editorState, editorState.getCurrentContent(), "change-block-type"),
    blockKey,
    0,
    url.length,
    {
      url
    }
  );
};

export { LINK_PREVIEW_TYPE, addLinkPreview, convertLinkPreviewToLink, createLinkPreviewData, fetchLinkPreview, shouldAddEmbed, shouldAddLinkPreview };
